export default "__VITE_ASSET__DQrEZCf6__"